import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      className="text-slate-200 py-12 px-4 text-base"
      style={{
        background: "linear-gradient(90deg, #282c34, #347fa4, #282c34)",
      }}
    >
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Kolumn 1 - Logotyp */}
        <div className="flex items-start justify-start">
          <Link to="/" className="block">
            <img src="/images/logo.webp" alt="Barnboken" className="h-[188px] w-auto" />
          </Link>
        </div>

        {/* Kolumn 2 - Fabelia Info */}
        <div>
          <h3 className="text-2xl font-bold mb-4 text-white">Barnboken</h3>
          <p className="text-slate-300 mb-4 leading-relaxed">
            Barnboken är en magisk plattform där AI förvandlar barnens idéer till unika böcker med ljud, bild och fantasi.
          </p>
          <p className="text-slate-300">
            Kontakt:{" "}
            <a href="mailto:hej@barnboken.se" className="text-white hover:underline">
              hej@barnboken.se
            </a>
          </p>
        </div>

        {/* Kolumn 3 - Utforska */}
        <div>
          <h4 className="text-xl font-semibold mb-4">Utforska</h4>
          <ul className="space-y-2 text-slate-300 text-lg">
            <li><Link to="/" className="hover:text-white transition-colors">Hem</Link></li>
            <li><Link to="/skapa" className="hover:text-white transition-colors">Skapa Bok</Link></li>
            <li><Link to="/produkter" className="hover:text-white transition-colors">Dina Böcker</Link></li>
            
          </ul>
        </div>

        {/* Kolumn 4 - Mer */}
        <div>
          <h4 className="text-xl font-semibold mb-4">Mer</h4>
          <ul className="space-y-2 text-slate-300 text-lg">
            <li><Link to="/affiliate" className="hover:text-white transition-colors">Affiliateprogram</Link></li>
            <li><Link to="/public" className="hover:text-white transition-colors">Publika Böcker</Link></li>
            <li><Link to="/integritetspolicy" className="hover:text-white transition-colors">Integritetspolicy</Link></li>

            <p className="text-slate-300">
            Kundtjänst:{" "}
            <a href="mailto:support@barnboken.se" className="text-white hover:underline">
              support@barnboken.se
            </a>
          </p>
          </ul>
        </div>
      </div>

      {/* Copyright */}
<div className="border-t border-slate-700 mt-12 pt-8 text-center text-white text-base space-y-2">
  <p>© {new Date().getFullYear()} Barnboken.se Alla rättigheter förbehållna.</p>
  <p>
    Brought to you by{" "}
    <a
      href="https://winberghmedia.com"
      target="_blank"
      rel="noopener noreferrer"
      className="text-white underline hover:text-slate-300 transition-colors"
    >
      Winbergh Media
    </a>
  </p>
</div>
    </footer>
  );
};

export default Footer;
